import styled from 'styled-components'

export const SearchResultsClearWrapper = styled.div`
  margin-left: 3px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 2px 3px 3px;

  svg {
    margin-top: 1px;
    color: ${({ theme }) => theme.secondary};
  }

  :hover {
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
`
